import { render, staticRenderFns } from "./RiskFilter.vue?vue&type=template&id=b8fd2712&scoped=true"
import script from "./RiskFilter.vue?vue&type=script&lang=js"
export * from "./RiskFilter.vue?vue&type=script&lang=js"
import style0 from "./RiskFilter.vue?vue&type=style&index=0&id=b8fd2712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fd2712",
  null
  
)

export default component.exports